import * as api from  './api'
import { AppDispatch } from 'src/app/store'
import * as reducers from './slice-reducers'
import { StockAlert, StockAlertPostPayload } from 'src/core/models'


export const getStockAlertList = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setStockAlertLoading(true))
    const data: StockAlert[] = await api.getStockAlertListAPI()
    dispatch(reducers.setStockAlertList(data))
    dispatch(reducers.setStockAlertLoading(false))
  }catch (error){
    dispatch(reducers.setStockAlertLoading(false))
  }
}

export const deleteStockAlert = (id: number) => async (dispatch: any) => {
  try {
    dispatch(reducers.setStockAlertDeleteLoading(true))
    await api.deleteStockAlertAPI(id)
    dispatch(reducers.setStockAlertDeleteSuccess(true))
    dispatch(reducers.setStockAlertDeleteLoading(false))
    dispatch(getStockAlertList())
  }catch (error){
    dispatch(reducers.setStockAlertDeleteLoading(false))
    dispatch(reducers.setStockAlertDeleteSuccess(false))
  }
}

export const createStockAlert = (payload: StockAlertPostPayload) => async (dispatch: any) => {
  try {
    dispatch(reducers.setStockAlertCreateLoading(true))
    await api.createStockAlertAPI(payload)
    dispatch(reducers.setStockAlertCreateSuccess(true))
    dispatch(getStockAlertList())
    dispatch(reducers.setStockAlertCreateLoading(false))
  }catch (error){
    dispatch(reducers.setStockAlertCreateLoading(false))
    dispatch(reducers.setStockAlertCreateSuccess(false))
  }
}
